import { render, staticRenderFns } from "./RoomCheckboxes.vue?vue&type=template&id=b830f418&lang=pug&"
import script from "./RoomCheckboxes.vue?vue&type=script&lang=js&"
export * from "./RoomCheckboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports